import { render, staticRenderFns } from "./AddProductSidebar.vue?vue&type=template&id=aa72f76a"
import script from "./AddProductSidebar.vue?vue&type=script&lang=js"
export * from "./AddProductSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports